<!-- Sección Sobre Nosotros -->
<section class="about-section" #aboutSection>
  <div class="container">
    <div class="about-content">

      <!-- Columna izquierda: Texto -->
      <div class="about-text animate-on-scroll" [class.visible]="isVisible" style="--delay: 0s">
        <h2 class="about-title">Sobre nosotros</h2>
        <p class="about-description">
          Somos LightCap Group, una firma fundada por agentes del mercado de capitales con amplia experiencia en
          asesoramiento a personas y PyMEs. Nuestra misión es ayudarte a planificar, proteger y potenciar tu dinero. Sin
          letra chica, sin productos enlatados, sin conflictos de interés.
        </p>
        <a routerLink="/about" class="btn-ver-mas">
          Ver más
        </a>
      </div>

      <!-- Columna derecha: Tarjetas de valores -->
      <div class="about-cards">
        <div class="cards-grid">

          <!-- Tarjeta 1: Transparencia -->
          <div class="value-card light animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.1s">
            <svg class="card-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
              <line x1="8" y1="21" x2="16" y2="21"></line>
              <line x1="12" y1="17" x2="12" y2="21"></line>
              <polyline points="22 7 13 12 10 9 6 13"></polyline>
            </svg>
            <span class="card-label">Transparencia</span>
          </div>

          <!-- Tarjeta 2: Visión Integral -->
          <div class="value-card dark animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.2s">
            <svg class="card-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="2" y1="12" x2="22" y2="12"></line>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z">
              </path>
            </svg>
            <span class="card-label">Visión Integral</span>
          </div>

          <!-- Tarjeta 3: Respaldo Institucional -->
          <div class="value-card dark animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.3s">
            <svg class="card-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              <polyline points="9 12 11 14 15 10"></polyline>
            </svg>
            <span class="card-label">Respaldo Institucional</span>
          </div>

          <!-- Tarjeta 4: Independencia -->
          <div class="value-card light animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.4s">
            <svg class="card-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
            </svg>
            <span class="card-label">Independencia</span>
          </div>

        </div>
      </div>

    </div>
  </div>
</section>